<template>
  <b-form-group
    :label="label"
    :label-class="{ required }"
    :invalid-feedback="error"
    :state="error ? false : null">
    <date-input-field
      v-bind="$props"
      @input="$emit('input', $event)"
    />
  </b-form-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import DateFieldMixin from 'vue-forms/mixins/DateFieldMixin';

export default {
  mixins: [ FormFieldMixin, DateFieldMixin ],
};
</script>
